module.exports = __webpack_public_path__ + "6c7bd23afcd2ef5d31c23bf9d6a9b06d.pdf";